import { AUTH_LOGGED_IN, AUTH_LOGGED_OUT } from '../actions/auth';

const initialState = {
  isAuthenticated: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGGED_IN:
      return {
        ...state,
        isAuthenticated: true
      };
    case AUTH_LOGGED_OUT:
      return {
        ...state,
        isAuthenticated: false
      };
    default:
      return state;
  }
};
